import { useState } from "react";
import IconChangeStage from "../../components/icons/IconChangeStage";

export default function PipelineButton({ conversation, stageTypes, stages, onUpdateConversation }) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="functional-panelbutton toolbar-popup-anchor" onClick={() => setIsOpen((prev) => !prev)}>
            <IconChangeStage fillColor="icon-yellow" style={{ height: 20, width: 20 }} />

            {isOpen ? (
                <div className="toolbar-popup" onClick={(e) => e.stopPropagation()}>
                    <p className="toolbar-popup-title">Pipeline (конвеєр)</p>

                    <select
                        value={conversation?.stageTypeId?.id ?? ""}
                        onChange={(e) => onUpdateConversation({ stageTypeId: Number(e.target.value) })}
                    >
                        <option value="" disabled>
                            Оберіть pipeline
                        </option>
                        {stageTypes.map((stageType) => (
                            <option key={stageType.id} value={stageType.id}>
                                {stageType.name}
                            </option>
                        ))}
                    </select>

                    {conversation?.stageTypeId ? (
                        <>
                            <p className="toolbar-popup-subtitle">Етапи цього pipeline</p>
                            <ul className="toolbar-popup-list toolbar-popup-list-readonly">
                                {(stages || []).map((stage) => (
                                    <li key={stage.id} style={{ borderLeft: `3px solid ${stage.color || "#7f7f7f"}` }}>
                                        <span>{stage.name}</span>
                                    </li>
                                ))}
                            </ul>
                        </>
                    ) : (
                        ""
                    )}
                </div>
            ) : (
                ""
            )}
        </div>
    );
}
